// `context.screen` vocabulary shared by the entry-context resolver, the prompt starters and the
// conversation-list screen chip. Kept out of `useOrbitEntryContext` so the two pure consumers do not
// have to import a router-bound hook module for a pair of string constants.
// TODO(AF-4): both values are the plan's working strings; the backend's final vocabulary is pending.
export const ORBIT_SCREEN_CUSTOMER_INSIGHTS = 'customer_intelligence_overview';
export const ORBIT_SCREEN_CUSTOMER_360 = 'customer_360';
export const ORBIT_SCREEN_CUSTOMER_PROFILE = 'customer_profile';

/** The open panel's fixed width; a leaf constant so shell chrome can read it without importing styles. */
export const ORBIT_PANEL_WIDTH = '500px';

// Temporarily disabled 2026-10-08 on request; flip to true to restore context detection.
export const ORBIT_CONTEXT_DETECTION_ENABLED = false;

/** The full-page Orbit workspace. The launcher and the side panel are not drawn on it. */
export const ORBIT_PAGE_PATH = '/p/orbit';
export const ORBIT_PAGE_ROUTE = `${ORBIT_PAGE_PATH}/*`;
